<template>
  <dara-row>
    <dara-col
      :sm="4"
      :md="2">
      <dara-icon
        class="mt-2 py-4"
        size="xl"
        icon="files" />
    </dara-col>
    <dara-col
      :sm="20"
      :md="22">
      <div class="mb--sm">
        <dara-small>{{ updatedAt }}</dara-small>
        <dara-small>{{ numberArticles }}</dara-small>
        <dara-small class="color--success">{{ readingTime }}</dara-small>
      </div>
      <dara-header v-truncate size="sm">
        <dara-track-link :id="track.id" :slug="track.slug">{{ track.name }}</dara-track-link>
      </dara-header>
      <dara-p
        v-truncate="2"
        color="regular">
        {{ track.description }}
      </dara-p>
    </dara-col>
  </dara-row>
</template>

<script>
import { formatToTimeAgo } from '@/helpers/date/date';
import { getTotalReadingTime } from '@/modules/article/article.service';
import { translate } from '@/services/translate.service';

import DaraTrackLink from '@/modules/track/components/TrackLink.vue';

export default {
  name: 'TrackListItem',
  components: {
    DaraTrackLink,
  },
  props: {
    track: {
      type: Object,
      required: true,
    },
  },
  computed: {
    updatedAt() {
      return `${formatToTimeAgo(this.track.updated_at)} · `;
    },
    numberArticles() {
      if (this.track.number_of_articles === 0) {
        return `${translate('no-articles')} · `;
      }
      return `${this.track.number_of_articles} ${translate('article').toLowerCase()}(s) · `;
    },
    readingTime() {
      if (this.track.articles) {
        return `${getTotalReadingTime(this.track.articles)} ${translate('min-read')}`;
      }
      return null;
    },
  },
};
</script>
